// extracted by mini-css-extract-plugin
module.exports = {"TopWrapper":"styles_TopWrapper__3ZcX7","TopWrapperPicture":"styles_TopWrapperPicture__2v2oJ"};